import { useCallback, useState } from 'react'
import api from '../../lib/commons/api'
import store from '../../store'
import { addScreenMessage, MessageLevel } from '../../store/messages'
import { intl } from '../../i18n'

const OPENAPI_DOCS_DOWNLOAD_PATH = '/api/v1/openapi-docs/download'
const OPENAPI_DOCS_FILE_NAME = 'sevend-mod-api-external.html'

// API トークン管理画面から OpenAPI ドキュメント(HTML)をダウンロードする共通処理。
// 取得失敗（未生成による 404 等）は握りつぶさず Snackbar でユーザーに通知する（規約 §5）。
// ダウンロード中は isDownloading を true にし、呼び出し側でボタンを無効化して多重実行を防ぐ。
export const useDownloadOpenApiDocs = (functionUuid: string) => {
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownload = useCallback(async () => {
    setIsDownloading(true)
    try {
      const blob = await api.functional.requestBlob(OPENAPI_DOCS_DOWNLOAD_PATH)
      const url = URL.createObjectURL(blob)
      try {
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = OPENAPI_DOCS_FILE_NAME
        anchor.click()
      } finally {
        URL.revokeObjectURL(url)
      }
    } catch (error) {
      // 障害調査のためエラー内容をログに残しつつ、ユーザーには Snackbar で通知する
      console.error('Failed to download OpenAPI docs', error)
      store.dispatch(
        addScreenMessage(functionUuid, {
          type: MessageLevel.ERROR,
          title: intl.formatMessage({ id: 'openApiDocs.error.download' }),
        })
      )
    } finally {
      setIsDownloading(false)
    }
  }, [functionUuid])

  return { handleDownload, isDownloading }
}
